import WardDashBoard from "../../HospitalPages/WardBedManagement/WardDashBoard";
import DoctorDashBoard from "../../HospitalPages/DoctorManagement/DoctorDashBoard";
import PatientDashBoard from "../../HospitalPages/Patient Management/PatientDashBoard";
import OpdDashBoard from "../../HospitalPages/OPD/OpdDashBoard";
import IpdDashBoard from "../../HospitalPages/IPD/IpdDashBoard";
import StaffDashBoard from "../../HospitalPages/Staff Management/StaffDashBoard";
import AccountDashBoard from "../../HospitalPages/AccountandBilling/AccountDashBoard";
import PharmacyMedicalStoreDashBoard from "../../HospitalPages/PharmacyMedicalStore/PharmacyMedicalStoreDashBoard";
import RadiologyDashBoard from "../../HospitalPages/Radiology/RadiologyDashBoard";
import MedicineInventoryDashBoard from "../../HospitalPages/MedicineInventory/MedicineInventoryDashBoard";
import ReportsAndAnalycisDashBoard from "../../HospitalPages/ReportsandAnalytics/ReportsAndAnalycisDashBoard";
import HospitalAdminDashBoard from "../../HospitalPages/HospitalAdmin/HospitalAdminDashBoard";
import HospitolSecurityAuditDashBoard from "../../HospitalPages/HospitalSecurityAudit/HospitolSecurityAuditDashBoard";



 export const hmsContent = {

//Patient Management
"Patient Management":PatientDashBoard,
// OPD
"OPD":OpdDashBoard,
//IPD
"IPD":IpdDashBoard,
// Ward /Bed Management
"Ward / Bed Management":WardDashBoard,
// Doctor Management
"Doctor Management":DoctorDashBoard,
//Staff Management
"Staff Management":StaffDashBoard,
//Accounts & Billing
"Accounts & Billing":AccountDashBoard,
// Pharmacy / Medical Store
"Pharmacy / Medical Store":PharmacyMedicalStoreDashBoard,
//Radiology / Lab Management
"Radiology / Lab Management":RadiologyDashBoard,
//Medicine / Inventory Management 
"Medicine / Inventory Management":MedicineInventoryDashBoard,
 //Reports & Analytics
"Reports & Analytics":ReportsAndAnalycisDashBoard,
//Administration (Admin Panel)
"Administration (Admin Panel)":HospitalAdminDashBoard,
//Security & Audit
"Security & Audit":HospitolSecurityAuditDashBoard,


 };


